import {PageIdentity} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';
import {JsonProperty} from '@outfoxx/jackson-js';

interface FileValue {
    url: string;
}

interface ListValue {

}

type Value = FileValue|ListValue|string;

interface Element {
    id: string;
}

interface ImageElement extends Element {
    value: FileValue
}

interface TagsElement extends Element {

}

interface Column {
    style: {viewMode: 'square'|'rectangle'};
    elements: Element[],
}

interface ImageColumn extends Column {
    image: ImageElement;
}

interface PreviewCard {
    column1: Column;
    column2: ImageColumn;
}

export interface PageItemInterface {
    id: string;
    card: PreviewCard

    pageIdentity: PageIdentity;

    getUrl(): any;
}

export interface Image {

}

export class Name {
    @JsonProperty()
    name: string;
    @JsonProperty()
    urlName: string;

    toString(): string {
        return this.name;
    }
}

export interface Slides {
    fileType: string,
    id: string,
    image: Image,
    lottie: null,
    sort: number,
    title: string,
    url: string
}

